module.exports = __webpack_public_path__ + "img/checklist-icon.54cbd823.png";